import { SpeedometerType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { useMemo } from "react";

export default function useBasicValues() {
  const speedometerTypeValues = useMemo(
    () =>
      Object.values(SpeedometerType)
        .filter((value) => typeof value === "number")
        .map((value) => value as SpeedometerType),
    [],
  );

  return {
    speedometerTypeValues,
  };
}
